exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---Huezm {\n  display: block; }\n\n.yearGroup---1OviN {\n  min-height: 24px;\n  padding: 4px 10px;\n  min-width: 35px;\n  border-radius: 15px;\n  margin-left: 8px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500; }\n\n.yg0 {\n  background-color: #e7b300; }\n\n.yg1 {\n  background-color: #ec7500; }\n\n.yg2 {\n  background-color: #f12800; }\n\n.yg3 {\n  background-color: #de1c9c; }\n\n.yg4 {\n  background-color: #6c32a8; }\n\n.yg5 {\n  background-color: #4461cd; }\n\n.yg6 {\n  background-color: #00b4ff; }\n\n.yg7 {\n  background-color: #44d62c; }\n\n.yg8 {\n  background-color: #249d46; }\n\n.yg9 {\n  background-color: #7c871d; }\n\n.yg10 {\n  background-color: #ad6f0c; }\n\n.yg11 {\n  background-color: #643808; }\n\n.yg12 {\n  background-color: #2a2a2a; }\n", ""]);

// exports
exports.locals = {
	"component": "component---Huezm",
	"yearGroup": "yearGroup---1OviN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/formatters/year-group-formatter/index.scss
// module id = 1173
// module chunks = 3